<template>
  <div :style="styles.base">
    <div
      v-if="styles.base.display !== 'none'"
      :style="containerStyle"
      :class="[
      'ceiba-dialog-container-container',
      'ceiba-dialog-container--default',
      !isMobile ? 'ceiba-dialog-container--pc' : ''
      ]"
      v-transfer-dom="$isInEditor && !isInPreview ? '': 'body'"
    >
      <transition>
        <div
          v-if="styles.base.display !== 'none' && isShowMask"
          class="ceiba-dialog-container-mask"
          @click="handleClickMask"
        ></div>
      </transition>
      <div class="ceiba-dialog-container-wrap" :style="wrapStyle">
        <div class="ceiba-dialog-container-main" :style="mainStyle">
          <slot></slot>
          <template v-if="options.close !== false">
            <button
              type="button"
              :style="configurationData.dialogConfig.closeStyle"
              v-if="configurationData.dialogConfig.closeStyle &&
              configurationData.dialogConfig.closeStyle.backgroundImage"
              :class="[
            configurationData.dialogConfig.closeLocation === 'bottom-center' ?
            'ceiba-dialog-container-close-bottom-center': '',
            configurationData.dialogConfig.closeLocation === 'right-top' ?
            'ceiba-dialog-container-close-right-top': '',
            configurationData.dialogConfig.closeLocation === 'top-right' ?
            'ceiba-dialog-container-close-top-right': '',
            configurationData.dialogConfig.closeLocation === 'in-right-top' ?
            'ceiba-dialog-container-close-in-right-top': '',
            ]"
              @click="handleClose"
            ></button>
            <a
              :class="[
            configurationData.dialogConfig.closeLocation === 'bottom-center' ?
            'ceiba-dialog-container-close-bottom-center': '',
            configurationData.dialogConfig.closeLocation === 'right-top' ?
            'ceiba-dialog-container-close-right-top': '',
            configurationData.dialogConfig.closeLocation === 'top-right' ?
            'ceiba-dialog-container-close-top-right': '',
            configurationData.dialogConfig.closeLocation === 'in-right-top' ?
            'ceiba-dialog-container-close-in-right-top': '',
            ]"
              href="javascript:;"
              @click="handleClose"
              v-else
            >×</a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@tencent/ceiba-base-components/index.scss';

import { componentBaseMixin } from '@tencent/ceiba-base-components';
import TransferDom from './v-transform-dom';

export default {
  name: 'CDialog',
  directives: {
    TransferDom,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      options: Object.assign(
        {
          closeStyle: '', // 个性化弹框关闭按钮自定义样式
          close: true,
          closeLocation: 'bottom-center',
          maskClickable: true, // 蒙层是否点击可关闭
        },
        this.configurationData.dialogConfig,
        {
          height: this.styles.base.height,
          width: this.styles.base.width,
        },
      ),
    };
  },
  computed: {
    containerStyle() {
      if (this.$isInEditor && !this.isInPreview) {
        return {
          position: 'absolute',
        };
      }

      return {
        position: 'fixed',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
      };
    },
    wrapStyle() {
      if (this.$isInEditor && !this.isInPreview) {
        return {
          width: `${this.styles.base.width}`,
          height: `${this.styles.base.height}`,
        };
      }
      return {
        position: 'fixed',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        width: `${this.styles.base.width}`,
        height: `${this.styles.base.height}`,
      };
    },
    mainStyle() {
      const { paddingTop } = this.configurationData.dialogConfig;
      const styles = {
        width: '100%',
        height: '100%',
        color: '#ffffff',
        '--close-to-top': paddingTop || (!this.isMobile ? '16px' : '0.16rem'), // 顶部默认 16px间距，优先读取配置项里面的顶部间距
        '--close-to-right': !this.isMobile ? '16px' : '0.16rem', // 右侧默认 16px间距
      };
      const { dialogStyle } = this.configurationData.dialogConfig;
      if (dialogStyle) {
        if (dialogStyle.backgroundImage) return Object.assign(styles, dialogStyle);
        return Object.assign(styles, dialogStyle, {});
      }
      return Object.assign(styles, {});
    },
    isShowMask() {
      return !this.$isInEditor || this.isInPreview;
    },
  },
  methods: {
    handleClose() {
      if (!this.$isInEditor || this.isInPreview) {
        this.$set(this.styles.base, 'display', 'none');
      }
      this.reportFunc('dialog_close', { stage: '1' });
    },
    handleClickMask() {
      if (this.options.maskClickable) {
        this.handleClose();
      }
    },
    // 数据上报
    reportFunc(key, obj) {
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData: obj || {},
        };
        this.reportClickRaw(params);
        console.log(`reportFunc  to key  ${key} report  data =`, params);
      }
    },
  },
};
</script>

<style lang="scss">
.ceiba-dialog-container-container {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
  top: 0;
  left: 0;
}

.ceiba-dialog-container-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1001;
  background-color: rgba(0, 0, 0, 0.7);
}

.ceiba-dialog-container-wrap {
  position: absolute;
  z-index: 1002;
}

.ceiba-dialog-container-main {
  background: no-repeat 0 0;
  background-size: 100% 100%;
  position: absolute;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.ceiba-dialog-container--default .ceiba-dialog-container-close-bottom-center {
  position: absolute;
  height: 0.64rem;
  width: 0.64rem;
  bottom: -0.7rem;
  left: 50%;
  margin: 0 auto;
  text-align: center;
  color: #ddd;
  font-size: 0.7rem;
  background-size: 100% 100%;
  transform: translateX(-50%);
  transform: translateX(-50%);
  transform: translateX(-50%);
  transform: translateX(-50%);
  transform: translateX(-50%);
}

.ceiba-dialog-container--default .ceiba-dialog-container-close-right-top {
  position: absolute;
  height: 0.64rem;
  width: 0.64rem;
  right: -0.7rem;
  top: 0;
  margin: 0 auto;
  text-align: center;
  color: #ddd;
  font-size: 0.7rem;
  background-size: 100% 100%;
}

.ceiba-dialog-container--default .ceiba-dialog-container-close-top-right {
  position: absolute;
  height: 0.64rem;
  width: 0.64rem;
  top: -0.7rem;
  right: 0;
  margin: 0 auto;
  text-align: center;
  color: #ddd;
  font-size: 0.7rem;
  background-size: 100% 100%;
}

// 右上内部
.ceiba-dialog-container--default .ceiba-dialog-container-close-in-right-top {
  position: absolute;
  height: 0.64rem;
  width: 0.64rem;
  top: var(--close-to-top);
  right: var(--close-to-right);
  margin: 0 auto;
  text-align: center;
  color: #ddd;
  font-size: 0.7rem;
  background-size: 100% 100%;
}

.ceiba-dialog-container--pc .ceiba-dialog-container-close-bottom-center {
  height: 40px;
  width: 40px;
  bottom: -45px;
  font-size: 40px;
}

.ceiba-dialog-container--pc .ceiba-dialog-container-close-right-top {
  height: 40px;
  width: 40px;
  right: -45px;
  top: 0;
  font-size: 40px;
}

.ceiba-dialog-container--pc .ceiba-dialog-container-close-top-right {
  height: 40px;
  width: 40px;
  top: -45px;
  right: 0;
  font-size: 40px;
}
// 右上内部
.ceiba-dialog-container--pc .ceiba-dialog-container-close-in-right-top {
  height: 40px;
  width: 40px;
  top: var(--close-to-top);
  right: var(--close-to-right);
  font-size: 40px;
}
</style>
